module.exports = __webpack_public_path__ + "assets/img/i-facebook.c3eeea4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/i-facebook.svg
// module id = ZlQX
// module chunks = 1